import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styles from './style.module.scss'
import { alertActions } from '../../_actions'
import { history } from '../../_helpers'
import { UserIcon, UserRoundIcon, PaymentIcon, ShutdownIcon, PlusIcon } from '../Icons'

export const DashboardTemplate = ({children}) => {
  return (
    <section className={styles['dashboard__template']}>
      {children} 
    </section>
  )
}

export const Header = ({title, link, children}) => {
  const [ dropdown, setDropdown ] = useState(false)

  const { username } = JSON.parse(sessionStorage.getItem('cellit_userdata'))

  const handleLogout = () => {
    sessionStorage.removeItem('selected_domain');
    sessionStorage.removeItem('cellit_domains');
    sessionStorage.removeItem('cellit_userdata');
    
    alertActions.resetStore()
    history.push('/signin');
  }

  return (
    <>
      <div className={styles['header__background--blue']}></div>
      <header>
        <div className={styles['title__group']}>
          <p>{title}</p>
          { link ?
            <Link to={link.path} className="btn btn-white header__only">
              <PlusIcon /> {link.label}
            </Link>
          : null}
        </div>

        {children}
      </header>

      <div className={styles['header__user-login']}>
        <div data-action="dropdown" onClick={() => setDropdown(!dropdown)}>
           <UserIcon />
        </div>
        <ul style={
          dropdown ? 
            {
              opacity: 1,
              transform: "translateY(0)",
              pointerEvents: "initial"
            }
          : {
              opacity: 0,
              transform: "translateY(10px)",
              pointerEvents: "none"
            }
        }>
          <li><p>Seja bem-vindo, <strong>{username}</strong></p></li>
          <li><Link to="/profile"><UserRoundIcon/> Meu perfil</Link></li>
          <li><Link to="/payment"><PaymentIcon /> Pagamentos</Link></li>
          <hr/>
          <li><a href={null} onClick={handleLogout}><ShutdownIcon /> Sair</a></li>
        </ul>
      </div>
      <div className={styles['header__user-backdrop']} style={dropdown ? {display: "block"} : {display: "none"}} onClick={() => setDropdown(false)}></div>
    </>
  )
}

export const Body = ({children}) => {
  return (
    <div className={styles['body__template']}>
      {children}
    </div>
  )
}